import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { type KeyBindingMap, type KeyBindingOptions, tinykeys } from 'tinykeys';
import { getBrowserDocument, getBrowserWindow } from '@/lib/utils/browser-window';
interface UseGlobalHotkeysOptions {
  enabled?: boolean;
  target?: Window | HTMLElement;
  tinykeysOptions?: KeyBindingOptions;
}

/**
 * Subscribe to keyboard shortcuts using tinykeys with SSR guards.
 */
export function useGlobalHotkeys(bindings, t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2,
    target,
    tinykeysOptions
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  let t4;
  if ($[2] !== bindings || $[3] !== enabled || $[4] !== target || $[5] !== tinykeysOptions) {
    t3 = () => {
      if (!(enabled && bindings)) {
        return;
      }
      if (Object.keys(bindings).length === 0) {
        return;
      }
      const documentTarget = getBrowserDocument();
      const resolvedTarget = target ?? documentTarget?.body ?? documentTarget?.documentElement ?? getBrowserWindow() ?? null;
      if (!resolvedTarget) {
        return;
      }
      const unsubscribe = tinykeys(resolvedTarget, bindings, tinykeysOptions);
      return () => {
        unsubscribe();
      };
    };
    t4 = [bindings, enabled, target, tinykeysOptions];
    $[2] = bindings;
    $[3] = enabled;
    $[4] = target;
    $[5] = tinykeysOptions;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
}